class RecommendedProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    const data = this.dataset
    const {limit = 4, productId = ''} = data

    if (!productId) {
      return
    }

    const requestUrl = `/recommendations/products?section_id=section-product-recommendations&limit=${limit}&product_id=${productId}`
    this.loadRecommendations(requestUrl, this)
  }

  loadRecommendations(url, element) {
    fetch(url)
    .then(response => response.text())
    .then((text) => {
      const html = document.createElement('div')
      html.innerHTML = text
      const recommendations = html.querySelector('recommended-products')

      if (recommendations && recommendations.innerHTML.trim().length) {
        element.innerHTML = recommendations.innerHTML

        new window.KeenSlider(
          element.querySelector("[data-recommended-products-el='slides']"),
          {
            selector: "[data-recommended-products-el='slide']",
            defaultAnimation: {
              duration: 1500,
            },
            loop: false,
            mode: 'snap',
            slides: {
              perView: 1.5,
              spacing: 20,
            },
            breakpoints: {
              '(min-width: 768px)': {
                slides: {
                  perView: 3,
                  spacing: 20,
                },
              },
              '(min-width: 1201px)': {
                slides: {
                  perView: 4,
                  spacing: 30,
                },
              },
            },
          },
          [
            window.BAO.Carousel.plugins.setInitialised(),
            window.BAO.Carousel.plugins.useArrows({
              next: element.querySelector("[data-recommended-products-el='next']"),
              previous: element.querySelector("[data-recommended-products-el='previous']"),
            })
          ],
        )
      }
    })
  }
}

if (!customElements.get('recommended-products')) {
  customElements.define('recommended-products', RecommendedProducts)
}
